/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Cra_ShortInputs */

const en_ticket_action_cra_short = /** @type {(inputs: Ticket_Action_Cra_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRA`)
};

const ja_ticket_action_cra_short = /** @type {(inputs: Ticket_Action_Cra_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRA`)
};

const fr_ticket_action_cra_short = /** @type {(inputs: Ticket_Action_Cra_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRA`)
};

const de_ticket_action_cra_short = /** @type {(inputs: Ticket_Action_Cra_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CRA`)
};

/**
* | output |
* | --- |
* | "CRA" |
*
* @param {Ticket_Action_Cra_ShortInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_cra_short = /** @type {((inputs?: Ticket_Action_Cra_ShortInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Cra_ShortInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_cra_short(inputs)
	if (locale === "ja") return ja_ticket_action_cra_short(inputs)
	if (locale === "fr") return fr_ticket_action_cra_short(inputs)
	return de_ticket_action_cra_short(inputs)
});